export function isStockBalanceColumnNumeric(columnKey) {
    switch (columnKey) {
        case 'brand':
        case 'article':
        case 'name':
            return false;
        default:
            return true;
    }
}
